import { Injectable} from '@angular/core';
import { SessionStorageService } from './session_storage';
import { PROPOSAL_ID, REQUEST_ID } from 'src/app/constants/constants';
import { P30APIService } from './api';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpResponse } from '@angular/common/http';
import { LegalEntity } from '../interfaces/LegalEntities';
import { isNonEmptyString } from 'ng-zorro-antd/core/util';
;

@Injectable ({
    providedIn: 'root'
})
export class DataServiceOwnershipRestructuringProposalOverview {
  legalEntitySelected: LegalEntity[] = [];
  commonEntityList: LegalEntity[] = [{
    companyName: "NA", ccn: "NA"
  }];
  isSaveForLaterClicked$ = new BehaviorSubject<boolean>(false);
  ownerShipLegalEntitySelectionForm: any;
  zxzz!: UntypedFormGroup;

  constructor(private session:SessionStorageService,
    private fb: UntypedFormBuilder,
    private apiService:P30APIService,
    private message: NzMessageService){ }

    checkBTNStatus(state: boolean) {
      this.isSaveForLaterClicked$.next(state);
    }

  getOwnershipRestructuringProposalOverview(): Observable<HttpResponse<any>>{
    return this.apiService.getProposalOverview(this.session.getItem(PROPOSAL_ID)).pipe(
      map(proposalOverview =>{
        return proposalOverview;
      })
    );
  }

  createOwnershipRestructuringProposalOverview(form: UntypedFormGroup, formEntity:UntypedFormGroup):Observable<HttpResponse<any>>{
    let summary = formEntity.controls["summaryLegalActivities"];
    const data = {
      "requestId": this.session.getItem(REQUEST_ID),
      "overviewOfProposal": form.controls["overviewOfProposal"].value,
      "businessReasonForProposal": form.controls["businessReasonForProposal"].value,
      "targetCompletionDate": '',
      "targetSigningDate": '',
      "nameOfShareHolderAndMore": '',
      "summaryofLegalEntitiesActivities": summary != undefined ? summary.value : '',
      "targetEffectiveDate": form.controls["targetEffectiveDate"].value,
      "proposedLegalEntityName": '',
      "countryorStateofIncorporation": '' }
    return this.apiService.createProposalOverview(this.session.getItem(PROPOSAL_ID), data).pipe(
      map(proposalOverview =>{
        return proposalOverview;
      })
    );
  }

  updateOwnershipRestructuringProposalOverview(form: UntypedFormGroup, formEntity:UntypedFormGroup): Observable<HttpResponse<any>>{
    let summary = formEntity.controls["summaryLegalActivities"];
    const data = {
      "requestId": this.session.getItem(REQUEST_ID),
      "overviewOfProposal": form.controls["overviewOfProposal"].value,
      "businessReasonForProposal": form.controls["businessReasonForProposal"].value,
      "targetCompletionDate": '',
      "targetSigningDate": '',
      "nameOfShareHolderAndMore": '',
      "summaryofLegalEntitiesActivities": summary != undefined ? summary.value : '',
      "targetEffectiveDate": form.controls["targetEffectiveDate"].value,
      "proposedLegalEntityName": '',
      "countryorStateofIncorporation": ''
    }
    return this.apiService.updateProposalOverview(this.session.getItem(PROPOSAL_ID), data).pipe(
      map(proposalOverview =>{
        return proposalOverview;
      })
    );
  }

  patchOwnershipRestructuringProposalOverviewDataToFormGroup(form: UntypedFormGroup,loader:boolean){
    this.apiService.getProposalOverview(this.session.getItem(PROPOSAL_ID)).subscribe({
      next: (event) => {
        if(event.body){
            form.patchValue({
            requestId: this.session.getItem(REQUEST_ID),
            summaryId: event.body[0].summaryId,
            overviewOfProposal: event.body[0].overviewOfProposal,
            businessReasonForProposal: event.body[0].businessReasonForProposal,
            targetCompletionDate: '',
            targetSigningDate: '',
            nameOfShareHolderAndMore: '',
            summaryofLegalEntitiesActivities: '',
            targetEffectiveDate: event.body[0].targetEffectiveDate,
            proposedLegalEntityName: '',
            countryorStateofIncorporation: ''
          });
        }
      },
      error: (err) =>{
        console.log("Unable to get proposal overview from the database table ",err);
      },
      complete: () =>{

      }
     });
  }
  createOwnershipRestructuringProposalOverviewWithFormData(form: UntypedFormGroup, formEntity:UntypedFormGroup,loader:boolean){
    this.createOwnershipRestructuringProposalOverview(form,formEntity).subscribe({
      next: (event) =>{
        this.getOwnershipRestructuringProposalOverview().subscribe({
          next: (event) =>{
            if(event.body){
              form.patchValue({
                requestId: this.session.getItem(REQUEST_ID),
                summaryId: event.body[0].summaryId,
                overviewOfProposal: event.body[0].overviewOfProposal,
                businessReasonForProposal: event.body[0].businessReasonForProposal,
                targetCompletionDate: '',
                targetSigningDate: '',
                nameOfShareHolderAndMore: '',
                summaryofLegalEntitiesActivities: '',
                targetEffectiveDate: event.body[0].targetEffectiveDate,
                proposedLegalEntityName: '',
                countryorStateofIncorporation: ''
              });
            }
          }
        });
      },
      error:(err) =>{
        console.log("unable to create proposal overview", err);
      },
      complete: () =>{

      }
    });
  }
  updateOwnershipRestructuringProposalOverviewWithFormData(form: UntypedFormGroup, formEntity:UntypedFormGroup,loader:boolean){
    this.updateOwnershipRestructuringProposalOverview(form,formEntity).subscribe({
      next: (event) =>{

      },
      error:(err) =>{
        console.log("unable to update proposal overview", err);

      },
      complete: () =>{

      }
    });
  }
  submitProposalOverview(form:UntypedFormGroup, formEntity:UntypedFormGroup, loader:boolean, tabClass:string):Promise<boolean>{
    if(form.valid){
      this.getOwnershipRestructuringProposalOverview().subscribe({
        next: (event) =>{
          if(event.body){
            this.updateOwnershipRestructuringProposalOverviewWithFormData(form,formEntity,loader);
          }else{
            this.createOwnershipRestructuringProposalOverviewWithFormData(form,formEntity, loader);
          }
        }
      });

      return Promise.resolve(true);
    }else{

      Object.values(form.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return Promise.resolve(false);
    }
  }

  reviewAndValidateOwnershipRestructuringProposalOverview(form:UntypedFormGroup): Promise<boolean>{
    const overviewOfProposalControl = form.controls["overviewOfProposal"];
    overviewOfProposalControl.setValidators([Validators.required]);
    overviewOfProposalControl.markAsDirty();
    overviewOfProposalControl.updateValueAndValidity();
    const businessReasonForProposalControl = form.controls["businessReasonForProposal"];
    businessReasonForProposalControl.setValidators([Validators.required]);
    businessReasonForProposalControl.markAsDirty();
    businessReasonForProposalControl.updateValueAndValidity();
    const targetCompletionDateControl = form.controls["targetEffectiveDate"];
    targetCompletionDateControl.setValidators([Validators.required]);
    targetCompletionDateControl.markAsDirty();
    targetCompletionDateControl.updateValueAndValidity();
    return Promise.resolve(form.valid);
  }


  getLegalEntities(): Observable<HttpResponse<any>> {
    return this.apiService.getLegalEntities(this.session.getItem(PROPOSAL_ID)).pipe(
      map(legalEntities => {
        return legalEntities;
      })
    );
  }


  reviewAndValidateOwnershipEntitySelection(form: UntypedFormGroup): Promise<boolean> {
    const entitySelectionControlValue = form.value.entityName;
    const commentsControlValue = form.value.entityComments;
    if (entitySelectionControlValue == 'NA') {
      if(commentsControlValue) {
        return Promise.resolve(true);
      } else {
        return Promise.resolve(false);
      }
    } else {
      return Promise.resolve(true);
    }
  }

  async submitOwnershipLegalEntitySelection(form: UntypedFormGroup): Promise<boolean> {
    if (form.valid) {
      this.getLegalEntities().subscribe({
        next: (event) => {
          if (event.body) {
            this.createOrUpdateLegalEntityRecordIfRecordExist(form, event.body);
          } else {
            this.createOrUpdateLegalEntityRecordIfNoRecord(form);
          }
        }
      });
      return Promise.resolve(true);
    } else {
      let status;
      this.isSaveForLaterClicked$.subscribe((result: boolean) => {
        switch(result) {
          case true: {
            status = true;
            this.saveForLater(form)
            break;
          }
          case false: {
            status = false;
            Object.values(form.controls).forEach(control => {
              if (control.invalid) {
                control.markAsDirty();
                control.updateValueAndValidity({ onlySelf: true });
              }
            });
            break;
          }
        }
      })
      if(status) {
        return Promise.resolve(true);
      } else {
        return Promise.resolve(false);
      }
    }
  }

  async createOrUpdateLegalEntityRecordIfRecordExist(form: UntypedFormGroup, event: any) {
    let commentsFormValue = form.controls['entityComments'].value;
    let entityNameValue = form.controls['entityName'].value;
    let leglaEntityPayload: LegalEntity = {
      ccn: (form.controls["entityName"].value) != 'NA' ?this.legalEntitySelected[0].ccn:'',
      companyName: entityNameValue,
      jurisdiction: (form.controls["entityName"].value) != 'NA' ?this.legalEntitySelected[0].jurisdiction:'',
      ownershipDetail: (form.controls["entityName"].value) != 'NA' ?this.legalEntitySelected[0].ownershipDetail:'',
      legalEntityComments: (form.controls["entityName"].value) != 'NA' ? '' : commentsFormValue,
      typeofLegalEntity: "Default",
      requestId: Number(this.session.getItem(REQUEST_ID))
    }
    if(event[0].legalEntityId) {
      leglaEntityPayload.legalEntityId = event[0]?.legalEntityId;
    }
    this.apiService.updateLegalEntity(this.session.getItem(PROPOSAL_ID), Number(event[0].legalEntityId), leglaEntityPayload).subscribe((res:any) => {
      console.log("updateLegalEntity => ", res);
    })

  }

  createOrUpdateLegalEntityRecordIfNoRecord(form: UntypedFormGroup) {
    let ccnval="";
    if(form.controls["entityName"].value!= undefined && form.controls["entityName"].value!="NA" && form.controls["entityName"].value!=""){
      ccnval= this.legalEntitySelected.filter(data => data.companyName == form.controls["entityName"].value)[0]?.ccn?this.legalEntitySelected.filter(data => data.companyName == form.controls["entityName"].value)[0]?.ccn+"":"NA";
    }
    else if(form.controls["entityName"].value !=undefined && form.controls["entityName"].value=="NA"){
      ccnval="NA";
    }
    if (ccnval!=''){
      let leglaEntity: LegalEntity = {
        //ccn: (form.controls["entityName"].value!="NA" && form.controls["entityName"].value!="")?this.legalEntitySelected.filter(data => data.companyName == form.controls["entityName"].value)[0]?.ccn+"": "NA",
        ccn:ccnval,
        companyName: (form.controls["entityName"].value)?form.controls["entityName"].value:'',
        jurisdiction: "",
        ownershipDetail: "",
        legalEntityComments: form.controls["entityComments"].value,
        typeofLegalEntity: ""
      }
      this.createLegalEntity(leglaEntity).subscribe({
        next: (event) => {
          return;
        }
      });
    }
  }

  createLegalEntity(legalEntity: LegalEntity): Observable<HttpResponse<any>> {
    const data = {
      "ccn": legalEntity.ccn,
      "companyName": legalEntity.companyName,
      "jurisdiction": legalEntity.jurisdiction,
      "ownershipDetail": legalEntity.ownershipDetail,
      "legalEntityComments": legalEntity.legalEntityComments ? legalEntity.legalEntityComments : null,
      "typeofLegalEntity": "Default",
      "requestId": Number(this.session.getItem(REQUEST_ID))
    }
    return this.apiService.createLegalEntity(this.session.getItem(PROPOSAL_ID), data).pipe(
      map(legelaEntities => {
        return legelaEntities;
      })
    )
  }

  createSummaryPayload(value: string) {
    const payload = {
      "requestId": this.session.getItem(REQUEST_ID),
      "overviewOfProposal": '',
      "businessReasonForProposal": '',
      "targetCompletionDate": '',
      "targetSigningDate": '',
      "nameOfShareHolderAndMore": '',
      "summaryofLegalEntitiesActivities": value,
      "targetEffectiveDate": '',
      "proposedLegalEntityName": '',
      "countryorStateofIncorporation": ''
    }
    return payload;
  }

  createEntitySelectionSummaryIfNoRecords(form: UntypedFormGroup): Observable<HttpResponse<any>> {
    let summaryValue = form.controls["summaryLegalActivities"].value;
    let payload = this.createSummaryPayload(summaryValue);
    return this.apiService.createProposalOverview(this.session.getItem(PROPOSAL_ID), payload).pipe(
      map(proposalOverview =>{
        return proposalOverview;
      })
    );
  }

  updateEntitySelectionSummaryIfRecordExist(form: UntypedFormGroup): Observable<HttpResponse<any>> {
    let summaryValue = form.controls["summaryLegalActivities"].value;
    let payload = this.createSummaryPayload(summaryValue);
    return this.apiService.updateProposalOverview(this.session.getItem(PROPOSAL_ID), payload).pipe(
      map(proposalOverview =>{
        return proposalOverview;
      })
    );
  }

  saveForLater(form: UntypedFormGroup) {
    this.getLegalEntities().subscribe({
      next: (event) => {
        if (event.body) {
          this.createOrUpdateLegalEntityRecordIfRecordExist(form, event.body);
          this.updateEntitySelectionSummaryIfRecordExist(form);
        } else {
          this.createOrUpdateLegalEntityRecordIfNoRecord(form);
          this.createEntitySelectionSummaryIfNoRecords(form);
        }
      }
    });
  }

  patchLegalEntitiesToFormGroup(loader: boolean, form: UntypedFormGroup) {
    let entityQuestions: any= [];
    let entityQuestionsSet: any= [];
    this.apiService.getEntityIndicatorQuestion(this.session.getItem(PROPOSAL_ID))
    .subscribe({
      next:(event) =>{
        if(event.body){
          entityQuestions = [...event.body];
        }
      }
    });
     this.getLegalEntities().subscribe({
       next: (event) => {
         if (event.body) {
           let entities: LegalEntity[] = [];
           entities = [...event.body];
           entities.forEach(item => {
             if (item.ccn == "NA") {
               const control = form.controls["entityComments"]
               control.setValue(item.legalEntityComments);
               control.updateValueAndValidity();
               form.controls["entityName"].setValue(item.ccn);
               form.updateValueAndValidity();
             }
            //  else {
            //    entityQuestionsSet = entityQuestions.filter((x: { legalEntityId: any; }) => x.legalEntityId === item.legalEntityId);
            //        const legalEntityForm = this.fb.group({
            //          legalEntityId: item.legalEntityId,
            //          legalEntityName:[item.companyName],
            //          ccn:item.ccn,//[this.legalEntities.filter(data =>data.companyName === leglaEntity.companyName)[0].ccn],
            //          companyName:item.companyName,
            //          jurisdiction:item.jurisdiction,
            //          ownershipDetail:item.ownershipDetail,
            //          entityQuestionsId: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].entityQuestionsId : '',
            //          activeRegistration: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveActiveRegistrationsInOtherStatesCountries : '',
            //          activeRegistrationComments:entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingActiveRegistrations : '',
            //          subsidiaries:  entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveSubsidiaries : '',
            //          subsidiariesComments: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingSubsidiaries: '',
            //          anyEmployees: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveAnyEmployees : '',
            //          anyEmployeesComments:  entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingEmployees : '',
            //          activeBankaccount: entityQuestionsSet.length > 0 ? entityQuestionsSet[0].haveActiveBankAccounts : '',
            //          activeBankaccountComments:  entityQuestionsSet.length > 0 ? entityQuestionsSet[0].commentsForHavingBankAccounts : '',
            //        })
            //    formArray.push(legalEntityForm);
            //  }

           })
         }

       },
       error: (err) => {
         console.log("Unable to get legal entity record in the database table ", err);
         this.message.error('Unable to retrieve legal entities!');
       },
       complete: () => {

       }
     });
   }


  reviewAndValidateEntitySelection(form: UntypedFormGroup): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const control = form.controls["entityComments"];
      const summaryControl = form.controls["summaryLegalActivities"];
      const entityNameControl = form.controls["entityName"];

      // Fetch legal entities and proposal overview in parallel to populate form before validating
      this.getLegalEntities().subscribe({
        next: (event) => {
          // Patch entityName and entityComments from the first entity record
          if (event.body && event.body.length > 0) {
            const entity = event.body[0];
            entityNameControl.setValue(entity.companyName);
            if (entity.companyName === 'NA') {
              control.setValue(entity.legalEntityComments);
            }
          }

          const controlEntityName = entityNameControl.value;

          if (!controlEntityName) {
            entityNameControl.setValidators([Validators.required]);
            entityNameControl.markAsDirty();
            entityNameControl.updateValueAndValidity();
            resolve(false);
            return;
          } else {
            entityNameControl.removeValidators([Validators.required]);
            entityNameControl.updateValueAndValidity();
          }

          // Fetch summaryLegalActivities from proposal overview
          this.apiService.getProposalOverview(this.session.getItem(PROPOSAL_ID)).subscribe({
            next: (overviewEvent) => {
              if (overviewEvent.body && overviewEvent.body.length > 0) {
                const summaryValue = overviewEvent.body[0].summaryofLegalEntitiesActivities;
                if (summaryValue) {
                  summaryControl.setValue(summaryValue);
                }
              }

              if (!summaryControl.value) {
                summaryControl.setValidators([Validators.required]);
                summaryControl.markAsDirty();
                summaryControl.updateValueAndValidity();
                resolve(false);
              } else {
                summaryControl.removeValidators([Validators.required]);
                summaryControl.updateValueAndValidity();

                if (controlEntityName === 'NA' && !isNonEmptyString(control.value)) {
                  control.setValidators([Validators.required]);
                  control.markAsDirty();
                  control.updateValueAndValidity();
                  resolve(false);
                } else {
                  control.removeValidators([Validators.required]);
                  control.updateValueAndValidity();
                  resolve(true);
                }
              }
            },
            error: () => resolve(true)  // overview fetch failed — entity name exists, allow through
          });
        },
        error: () => {
          // API failed — validate against whatever is already in the form
          const controlEntityName = entityNameControl.value;
          if (!controlEntityName) {
            entityNameControl.setValidators([Validators.required]);
            entityNameControl.markAsDirty();
            entityNameControl.updateValueAndValidity();
            resolve(false);
          } else if (!summaryControl.value) {
            summaryControl.setValidators([Validators.required]);
            summaryControl.markAsDirty();
            summaryControl.updateValueAndValidity();
            resolve(false);
          } else if (controlEntityName === 'NA' && !isNonEmptyString(control.value)) {
            control.setValidators([Validators.required]);
            control.markAsDirty();
            control.updateValueAndValidity();
            resolve(false);
          } else {
            resolve(true);
          }
        }
      });
    });
  }
}
